import {UsuarioInfoNavLink, UsuarioInfoProps} from "@components/contas/UsuarioInformacao.tsx";
import {TableCell, TableRow} from "@mui/material";
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {useEffect, useState} from "react";
import {CheckOutlined, ClearOutlined} from "@mui/icons-material";
import {ToDateTimeDefault} from "@shared/MathHelp.ts";

interface UsuarioInfoRowProps extends Omit<UsuarioInfoProps, 'variant' | 'usuarioId' | 'events' | 'value'> {
    value?: IUsuario
}

export function UsuarioInfoRow(props: UsuarioInfoRowProps) {
    const {value, EndComponent} = props
    const {tryGet} = useUsuario()
    const [usuario, setUsuario] = useState<IUsuario | undefined>(value);

    useEffect(() => {
        if (usuario == null && props.expectedId != null) {
            tryGet({id: props.expectedId}).then(x => setUsuario(x))
        }
    }, [usuario]);

    return (usuario != null && <TableRow>
            <TableCell><UsuarioInfoNavLink value={usuario}
                                           slotProps={{chip: {tableMode: true}}}
                                           displayMode={'id'}
                                           hideYou/></TableCell>
            <TableCell><UsuarioInfoNavLink value={usuario}
                                           slotProps={{chip: {tableMode: true}}}/>
            </TableCell>
            <TableCell>{usuario.email}</TableCell>
            <TableCell>{usuario.isAtivo ? <CheckOutlined/> : <ClearOutlined/>}</TableCell>
            <TableCell>{ToDateTimeDefault(usuario.ultimoLogin)}</TableCell>
            <TableCell>{EndComponent?.(usuario)}</TableCell>
        </TableRow>
    )
}